import Error404Container from "../../../components/pages/other/Error404";

const Error404 = () => {
  return <Error404Container />;
};

export default Error404;
